import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import SidebarOption from './SidebarOption';
import Logo from '../common/Logo_Round';

const HelpSidebar = ({
    page_filter,
    auth: {
        isAuthenticated
    }
}) => {

    return (
        <div className="sidebar" style={{display:'flex', position:'relative', flexDirection: 'column'}}>
            {/* Logo Container */}
            <div onClick={() => window.location = '/'} style={{gap: '.5rem', margin: '1.5rem 0', display: 'flex', alignItems: 'center', cursor: 'pointer'}}>
                {/* Img - Logo */}
                <img alt="Interview Cheater" loading="lazy" width="20" height="20" decoding="async" src={Logo} style={{borderRadius: '50%', width: '50px', height: '50px'}} />
            </div>

            {/* Spacer */}
            <div style={{height: '.5rem'}}></div>

            {/* Button */}
            {!isAuthenticated && (
                <Link to="/signin">
                    <button style={{width: '100%', boxShadow: '0 0 20px rgba(255,191,0,.3)', background: '#FFFF00', color:'#000', fontWeight: "bold", fontSize: '.875rem', lineHeight: '1.25rem', padding: '.5rem 1rem', borderRadius: '14px', cursor: 'pointer'}}>
                        Sign In
                    </button>
                </Link>
            )}

            <div style={{height: '1.5rem'}}></div>

            {/* --- Sidebar options */}  
            <h3 style={{fontWeight: 500, fontSize: '13px', margin: '0 0 .5rem'}}>
                General
            </h3>
            <SidebarOption help_sidebarOption active={page_filter === "getting-started"} text="Getting Started" link="/help?section=getting-started"/>
            <SidebarOption help_sidebarOption active={page_filter === "configuration"} text="Language Configuration" link="/help?section=configuration" />
            <SidebarOption help_sidebarOption active={page_filter === "undetectability"} text="Undetectability" link="/help?section=undetectability"/>
            
            <h3 style={{fontWeight: 500, fontSize: '13px', margin: '1.5rem 0 .5rem'}}>
                Account and Subscription
            </h3>
            <SidebarOption help_sidebarOption active={page_filter === "cancel-subscription"} text="Cancel Subscription" link="/help?section=cancel-subscription" />
            <SidebarOption help_sidebarOption active={page_filter === "refund-policy"} text="Refund Policy" link="/help?section=refund-policy"/>

            <h3 style={{fontWeight: 500, fontSize: '13px', margin: '1.5rem 0 .5rem'}}>
                Troubleshooting
            </h3>
            <SidebarOption help_sidebarOption active={page_filter === "out-of-credits"} text="Says out of credits" link="/help?section=out-of-credits" />
            <SidebarOption help_sidebarOption active={page_filter === "cant-see-screen"} text="Can't see screen" link="/help?section=cant-see-screen"/>
            <SidebarOption help_sidebarOption active={page_filter === "shows-when-sharing"} text="Shows when I share screen" link="/help?section=shows-when-sharing" />
            <SidebarOption help_sidebarOption active={page_filter === "report-issue"} text="Report an issue" link="/report-issues" />

            <h3 style={{fontWeight: 500, fontSize: '13px', margin: '1.5rem 0 .5rem'}}>
                Contact Us
            </h3>
            <p style={{color: 'rgb(212,212,216)', fontSize: '13px', margin: 0}}>
                support@interviewcheater.com
            </p>
            {/* Spacer - add space to the bottom for better scroll experience */}
            <div style={{height: '50px'}}></div>
        </div>
    )
}

export default HelpSidebar;